module.exports = "/_next/static/resources/photo-2-2df53c134fec68011cb729d07424af18.jpg";